<div>
  <app-table [table]="txnListData"></app-table>
  <button (click)="doRefresh()">Refresh</button>
</div>
